import React from 'react';

import FlyoutLeft from '../../components/common/FlyoutLeft';
import ClickableStatusButton from '../../components/common/Buttons/ClickableStatusButton';

import { useCommonStore } from '../../stores/commonStore';

import { FSNModel, GoLiveFSNModel } from '../../types/common';
import DownloadCSV from './DownloadCSV';

interface FSNListProps {
    showDownloadCSV?: boolean;
    showVisualQC?: boolean;
    fsns?: FSNModel[] | GoLiveFSNModel[] | null;
    onFSNClick?: () => void;
}

const FSNList = ({ fsns, onFSNClick, showDownloadCSV = false, showVisualQC = false }: FSNListProps) => {
    const setActiveProduct = useCommonStore((state) => state.setActiveFSN);

    const handleOnClick = (fsn) => {
        if (fsn.status) {
            setActiveProduct(fsn.fsn);

            if (onFSNClick) {
                onFSNClick();
            }
        }
    };

    return (
        <FlyoutLeft open={true}>
            <div className="flex flex-col h-auto">
                <div className="flex-grow  body-bg-color overflow-scroll" style={{ backgroundColor: '#F9FAFB', height: 'calc(100vh - 108px - 64px)' }}>
                    <button onClick={() => {}} type="button" className={`flex flex-col gap-1 py-4 px-4 mt-1 text-center text-sm  w-full`} style={{ backgroundColor: '#F9FAFB', height: 44 }}>
                        Product
                    </button>
                    {fsns?.map((fsn) => (
                        <ClickableStatusButton key={fsn.fsn} showVisualQC={showVisualQC} onClick={() => handleOnClick(fsn)} fsn={fsn} fullWidth />
                    ))}
                </div>

                {showDownloadCSV ? (
                    <div style={{ height: 108, backgroundColor: '#F9FAFB', borderTop: '1px solid rgb(229, 231, 235)' }}>
                        <DownloadCSV />
                    </div>
                ) : null}
            </div>
        </FlyoutLeft>
    );
};

export default React.memo(FSNList);
